import { Badge } from '~/components/UI/Badge'

import { logoImageSizes } from './constants'

type LogoSizeBadgesProps = {
  isMultiSizePublisher: boolean
}

const LogoSizeBadges: React.FC<LogoSizeBadgesProps> = ({
  isMultiSizePublisher
}) => {
  if (isMultiSizePublisher) {
    return (
      <>
        {logoImageSizes.map(item => (
          <div key={item.size}>
            <Badge template="primary">{item.size}</Badge>
          </div>
        ))}
      </>
    )
  }

  return <Badge template="primary">{logoImageSizes[0].size}</Badge>
}

export default LogoSizeBadges
